<template>
  <div
    id="recommendation-input"
    class="p-4 bg-white border border-grey-200 rounded"
  >
    <div class="space-y-1 mb-4">
      <div class="text-grey">
        <BlTextSubtitle2 text="Passing" />
        <span
          :class="{
            'text-light-purple hover:text-dark-purple-100 cursor-pointer relative': navigateSuccessMetric
          }"
        >
          <BlTextSubtitle2
            text="success metric"
            :class="{ 'underline ': navigateSuccessMetric }"
          />
          <BlTextSubtitle2
            v-if="navigateSuccessMetric"
            text="⮥"
            class="absolute -right-4 bottom-0 font-normal"
          />
        </span>
      </div>
      <div class="text-sm text-grey-400 flex items-center gap-2">
        <BlTextBody2 text="Updating the current target's status from" />
        <StatusChip status="in_progress" dense />
        <BlTextBody2 text="to" />
        <StatusChip status="mastered" dense />
      </div>
    </div>
    <div class="pl-8 space-y-4">
      <div class="space-y-1">
        <div class="flex items-center gap-2">
          <BlInputToggle
            :checked="totalSuccessChecked"
            :class="{ 'opacity-75': totalSuccessChecked }"
            @changed="
              onChangeToggle({
                totalSuccessChecked: !totalSuccessChecked,
                consecutiveSuccessChecked
              })
            "
          />
          <BlTextSubtitle2 text="Total success" class="text-sm text-grey" />
        </div>
        <div class="flex items-center flex-wrap gap-x-1">
          <BlTextBody2 text="Receive a recommendation after completing" />
          <BlTextBody2 class="font-bold" text="at least" />
          <input
            type="number"
            v-model="totalSuccessInput"
            @input="onInput"
            min="1"
            class="px-2 text-center rounded border border-grey-200 text-grey h-8 w-10 outline-none focus:border-light-purple"
            :disabled="!totalSuccessChecked"
            :class="{ 'opacity-50': !totalSuccessChecked }"
          />
          <BlTextBody2 text="successful session(s)." />
        </div>
      </div>
      <div class="space-y-1">
        <div class="flex items-center gap-2">
          <BlInputToggle
            :checked="consecutiveSuccessChecked"
            :class="{ 'opacity-75': consecutiveSuccessChecked }"
            @changed="
              onChangeToggle({
                consecutiveSuccessChecked: !consecutiveSuccessChecked,
                totalSuccessChecked
              })
            "
          />
          <BlTextSubtitle2
            text="Consecutive success"
            class="text-sm text-grey"
          />
        </div>
        <div class="flex items-center flex-wrap gap-x-1 text-sm">
          <BlTextBody2
            text="Receive a recommendation only if the session is successful for"
          />
          <input
            type="number"
            v-model="consecutiveSuccessInput"
            @input="onInput"
            min="2"
            class="px-2 text-center rounded border border-grey-200 text-grey h-8 w-10 outline-none focus:border-light-purple"
            :disabled="!consecutiveSuccessChecked"
            :class="!consecutiveSuccessChecked ? 'opacity-50' : ''"
          />
          <BlTextBody2 class="font-bold" text="consecutive session(s)." />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusChip from "../StatusChip.vue";
import BlIcon from "../../../BlIcon.vue";
import BlTextBody2 from "../../../BlTextBody2.vue";
import BlTextSubtitle1 from "../../../BlTextSubtitle1.vue";
import BlTextSubtitle2 from "../../../BlTextSubtitle2.vue";
import BlInputCheck from "../../../BlInputCheck.vue";
import BlInputToggle from "../../../BlInputToggle.vue";

export default {
  name: "ActionRecommendationInput",
  components: {
    StatusChip,
    //
    BlIcon,
    BlTextBody2,
    BlTextSubtitle1,
    BlTextSubtitle2,
    BlInputCheck,
    BlInputToggle
  },
  props: {
    navigateSuccessMetric: { type: Boolean, default: false },
    totalSuccess: { type: Number | String, default: null, required: false },
    consecutiveSuccess: {
      type: Number | String,
      default: null,
      required: false
    }
  },
  data() {
    return {
      totalSuccessChecked: false,
      totalSuccessInput: null,
      consecutiveSuccessChecked: false,
      consecutiveSuccessInput: null
    };
  },
  watch: {
    totalSuccess(val) {
      this.setupTotalSuccess(val);
    },
    consecutiveSuccess(val) {
      this.setupConsecutiveSuccess(val);
    }
  },
  mounted() {
    this.setupTotalSuccess(this.totalSuccess);
    this.setupConsecutiveSuccess(this.consecutiveSuccess);
  },
  methods: {
    setupTotalSuccess(val) {
      if (val !== null) {
        this.totalSuccessChecked = true;
        this.totalSuccessInput = val;
      }
    },
    setupConsecutiveSuccess(val) {
      if (val !== null) {
        this.consecutiveSuccessChecked = true;
        this.consecutiveSuccessInput = val;
      }
    },
    onChangeToggle({ totalSuccessChecked, consecutiveSuccessChecked }) {
      this.totalSuccessChecked = totalSuccessChecked;
      this.consecutiveSuccessChecked = consecutiveSuccessChecked;
      this.onInput();
    },
    onInput() {
      const data = {
        total_success_checked: this.totalSuccessChecked,
        total_success: this.totalSuccessInput,
        consecutive_success_checked: this.consecutiveSuccessChecked,
        consecutive_success: this.consecutiveSuccessInput
      };
      this.$emit("input", data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/target/modal/ActionRecommendationInput.vue